<template>
  <div>
    <div class="getting-started-container">
      <!-- BLOCK ONE -->
      <template v-if="getSummerStatus !== 'active'">
        <div class="item-block white rounded-5" v-if="diagnostics.length > 0">
          <!-- TOP ROW -->
          <GettingStartedTop type="diagnostic"></GettingStartedTop>

          <!-- BOTTOM ROW -->
          <div class="bottom-row d-flex w-100">
            <!-- INVISIBLE AVATAR -->
            <div class="avatar invisible mr-0 mr-sm-2 d-none d-md-block"></div>
            <!-- INVISIBLE AVATAR -->

            <!-- INFO CONTAINER -->
            <div
              class="recommendation-container position-relative rounded-5 mb-5"
            >
              <!-- RECOMMENDATION CONTENT -->
              <div class="recommendation-content w-100 position-relative">
                <div class="title-one color_grey_dark mb-3">
                  Get started on your journey to mastery. Complete the scheduled
                  pretest to begin.
                </div>

                <!-- RECOMMENDATION ROW -->
                <div
                  class="recommendation-row pt-2 d-flex justify-content start align-items-start nowrap"
                >
                  <div
                    :key="key"
                    v-for="(item, key) in diagnostics"
                    class="mr-2"
                  >
                    <RecommendCard
                      theme="light"
                      :topic="item"
                      :subject_id="item.id"
                      card_type="diagnostic"
                      :card_img="item.image"
                      :card_title="item.name"
                      :card_topic="item.name"
                      :show_lock="false"
                      :show_button="false"
                      :custom_height="true"
                      custom_height_value="diagnostic-card-height"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- BLOCK FIVE (INVITE SCHOOL) -->
      <template v-if="!enrolled">
        <div class="item-block white rounded-5" v-if="show_invite_school_block">
          <!-- TOP ROW -->
          <GettingStartedTop></GettingStartedTop>

          <!-- BOTTOM ROW -->
          <div class="bottom-row d-flex w-100">
            <!-- INVISIBLE AVATAR -->
            <div class="avatar invisible mr-0 mr-sm-2 d-none d-md-block"></div>
            <!-- INVISIBLE AVATAR -->

            <!-- INFO CONTAINER -->
            <div
              class="cover position-relative brand_inverse_border w-100 overflow-hidden rounded-10"
            >
              <div
                class="info-container position-relative brand_inverse_light_bg"
              >
                <img v-lazy="localImg('InfoBanner.png')" alt class="full-img" />
              </div>

              <!-- BOTTOM CONTENT -->
              <div class="bottom-content">
                <div class="title-text brand_navy font-weight-bold">
                  Experience Your School on Gradely
                </div>

                <div class="meta-text color_ash">
                  Invite your school to receive homework, exams, lesson notes
                  and more directly on Gradely.
                </div>

                <!-- BUTTON -->
                <template v-if="invite_school">
                  <button
                    disabled
                    v-if="account_type === 'parent'"
                    class="btn btn-accent font-weight-500 mx-0"
                  >
                    School Invited
                  </button>
                </template>

                <template v-else>
                  <button
                    v-if="account_type === 'parent'"
                    class="btn btn-accent font-weight-500 mx-0"
                    @click="$emit('connectSchool')"
                  >
                    Connect School
                  </button>
                </template>

                <template v-if="connected_to_school">
                  <button
                    disabled
                    v-if="account_type === 'student'"
                    class="btn btn-accent font-weight-500 mx-0"
                  >
                    School Connected
                  </button>
                </template>

                <template v-else>
                  <button
                    v-if="account_type === 'student'"
                    class="btn btn-accent font-weight-500 mx-0"
                    @click="toggleClassModal"
                  >
                    Connect with your School
                  </button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- BLOCK TWO -->
      <template v-if="getSummerStatus !== 'active'">
        <template v-if="diagnostics.length === 0">
          <template v-if="recommendation_done === false">
            <div
              class="item-block white rounded-5"
              v-if="recommendations.length"
            >
              <!-- TOP ROW -->
              <GettingStartedTop type="recommendation"></GettingStartedTop>

              <!-- BOTTOM ROW -->
              <div class="bottom-row d-flex w-100">
                <!-- INVISIBLE AVATAR -->
                <div
                  class="avatar invisible mr-0 mr-sm-2 d-none d-md-block"
                ></div>
                <!-- INVISIBLE AVATAR -->

                <!-- INFO CONTAINER -->
                <div
                  class="recommendation-container position-relative rounded-5 mb-5"
                >
                  <!-- RECOMMENDATION CONTENT -->
                  <div class="recommendation-content w-100 position-relative">
                    <div class="title-one color_grey_dark mb-3">
                      Recommended for {{ child_name }} today
                    </div>

                    <!-- RECOMMENDATION ROW -->
                    <div
                      class="recommendation-row pt-2 d-flex justify-content start align-items-start nowrap"
                    >
                      <div
                        class="mr-2"
                        v-for="(recommend, index) in recommendations"
                        :key="index"
                      >
                        <RecommendCard
                          theme="light"
                          :topic="recommend.topic"
                          v-if="recommend.type == 'single'"
                          :topic_type="recommend.type"
                          :practice_id="Number(recommend.id)"
                          :subject_id="recommend.topic.subject_id"
                          recommendation_type="daily"
                          card_type="practice"
                          :card_img="recommend.topic.image"
                          card_title="Single Practice"
                          :card_topic="recommend.topic.topic"
                          :show_lock="subscription_status"
                          :completed_card="recommend.is_done"
                          :show_button="false"
                          :custom_height="true"
                          custom_height_value="daily-recommendation-card-height"
                        />

                        <RecommendCard
                          theme="light"
                          :topic="recommend.topic"
                          v-else-if="recommend.type == 'mix'"
                          :topic_data="recommend.topic"
                          :topic_type="recommend.type"
                          :practice_id="Number(recommend.id)"
                          :subject_id="recommend.topic[0].subject_id"
                          recommendation_type="daily"
                          card_type="practice"
                          :card_img="recommend.topic[0].image"
                          card_title="Mix Practice"
                          :card_topic="recommend.topic[0].topic"
                          :show_lock="subscription_status"
                          :completed_card="recommend.is_done"
                          :show_button="false"
                          :custom_height="true"
                          custom_height_value="daily-recommendation-card-height"
                        />

                        <RecommendCard
                          v-else
                          theme="light"
                          card_type="video"
                          card_title="Video Lesson"
                          :video_id="recommend.token"
                          :practice_id="Number(recommend.id)"
                          recommendation_type="daily"
                          :card_img="recommend.image || 'VideoCardOne.png'"
                          :card_topic="recommend.new_title"
                          :card_meta="recommend.time_remaining"
                          :show_lock="subscription_status"
                          :completed_card="recommend.is_done"
                          :custom_height="true"
                          custom_height_value="daily-recommendation-card-height"
                        ></RecommendCard>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>

      <!-- BLOCK SIX (BOOK TUTOR) -->
      <template v-if="post_content_length === 0">
        <div class="item-block white rounded-5">
          <!-- TOP ROW -->
          <GettingStartedTop type="tutor"></GettingStartedTop>

          <!-- BOTTOM ROW -->
          <div class="bottom-row d-flex w-100">
            <!-- INVISIBLE AVATAR -->
            <div class="avatar invisible mr-0 mr-sm-2 d-none d-md-block"></div>
            <!-- INVISIBLE AVATAR -->

            <!-- INFO CONTAINER -->
            <div
              class="cover position-relative brand_inverse_border w-100 overflow-hidden rounded-10"
            >
              <div
                class="info-container position-relative brand_inverse_light_bg"
              >
                <img
                  v-lazy="
                    localImg(
                      getSummerStatus === 'active'
                        ? 'SummerTutor.png'
                        : 'TutorBanner.png'
                    )
                  "
                  alt
                  class="full-img"
                />
              </div>

              <!-- BOTTOM CONTENT -->
              <div class="bottom-content">
                <div class="title-text brand_navy font-weight-bold">
                  {{
                    getSummerStatus === "active"
                      ? "Book a hands-on tutor session"
                      : "Help your child excel"
                  }}
                </div>

                <div class="meta-text color_ash">
                  {{
                    getSummerStatus === "active"
                      ? "You don't need to wait for group classes. Book a hands-on tutor session now."
                      : " Book a private or group lessons in any subject for your child's learning needs."
                  }}
                </div>

                <!-- BUTTON -->

                <button
                  class="btn btn-accent d-table px-4 font-weight-500 mx-0"
                  @click="redirectToLandingPage"
                >
                  <span class="ml-2 position-relative" style="top: 1.5px"
                    >Learn More</span
                  >
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- BLOCK THREE (CATCHUP) -->
      <template v-if="back_to_school_status">
        <div class="item-block white rounded-5">
          <!-- TOP ROW -->
          <GettingStartedTop type="back_to_school"></GettingStartedTop>

          <!-- BOTTOM ROW -->
          <div class="bottom-row d-flex w-100">
            <!-- INVISIBLE AVATAR -->
            <div class="avatar invisible mr-0 mr-sm-2 d-none d-md-block"></div>
            <!-- INVISIBLE AVATAR -->

            <!-- INFO CONTAINER -->
            <div class="position-relative w-100 overflow-hidden rounded-10">
              <div class="title-one color_grey_dark mb-3">
                Jumpstart your journey to mastery with N10,000/year and win a
                #Back2School gift
              </div>

              <div class="info-container-sm position-relative">
                <img
                  v-lazy="localImg('backToSchoolPromoBanner.png')"
                  alt
                  class="full-img rounded-10"
                />
              </div>

              <!-- BOTTOM CONTENT -->
              <div @click="logClaimClick">
                <router-link
                  :to="
                    '/' + account_type + '/settings/upgrade-plan?type=catchup'
                  "
                  class="btn btn-accent mx-0 mt-4 d-table font-weight-500"
                  >Claim offer now</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- BLOCK THREE (CATCHUP) -->
      <template v-if="subscription_status === false">
        <template v-if="post_content_length === 0">
          <div class="item-block white rounded-5">
            <!-- TOP ROW -->
            <GettingStartedTop type="catchup"></GettingStartedTop>

            <!-- BOTTOM ROW -->
            <div class="bottom-row d-flex w-100">
              <!-- INVISIBLE AVATAR -->
              <div
                class="avatar invisible mr-0 mr-sm-2 d-none d-md-block"
              ></div>
              <!-- INVISIBLE AVATAR -->

              <!-- INFO CONTAINER -->
              <div
                class="cover position-relative brand_inverse_border w-100 overflow-hidden rounded-10"
              >
                <div
                  class="info-container position-relative brand_inverse_light_bg"
                >
                  <img
                    v-lazy="localImg('PromoBannerBg.png')"
                    alt
                    class="full-img"
                  />
                  <!-- TEXT CONTENT -->
                  <div
                    class="text-content w-100 h-100 position-absolute d-flex flex-column justify-content-center align-items-center"
                  >
                    <img v-lazy="localImg('Gradely.png')" alt="" />
                    <div class="brand_navy font-weight-bold text">CatchUp!</div>
                  </div>
                </div>

                <!-- BOTTOM CONTENT -->
                <div class="bottom-content">
                  <div class="title-text brand_navy font-weight-bold">
                    Try Catchup!
                  </div>

                  <div class="meta-text color_ash">
                    Unlock hundreds of gamified quizzes, video lessons and study
                    materials.
                  </div>

                  <template v-if="subscription_status === false">
                    <router-link
                      :to="
                        '/' +
                          account_type +
                          '/settings/upgrade-plan?type=catchup'
                      "
                      class="btn btn-accent mx-0 d-table font-weight-500"
                      >Subscribe Now</router-link
                    >
                  </template>

                  <template v-else>
                    <router-link
                      :to="
                        '/' + account_type + '/catchup/' + getSelectedChildID
                      "
                      class="btn btn-accent mx-0 d-table font-weight-500"
                      >Go to Catchup</router-link
                    >
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>

      <!-- BLOCK FIVE (SUMMER SCHOOL) -->
      <template
        v-if="getSummerStatus === 'active' && post_content_length === 0"
      >
        <div class="item-block white rounded-5">
          <!-- TOP ROW -->
          <GettingStartedTop type="summer"></GettingStartedTop>

          <!-- BOTTOM ROW -->
          <div class="bottom-row d-flex w-100">
            <!-- INVISIBLE AVATAR -->
            <div class="avatar invisible mr-0 mr-sm-2 d-none d-md-block"></div>
            <!-- INVISIBLE AVATAR -->

            <!-- INFO CONTAINER -->
            <div
              class="cover position-relative brand_inverse_border w-100 overflow-hidden rounded-10"
            >
              <div
                class="info-container position-relative brand_inverse_light_bg"
              >
                <img
                  v-lazy="localImg('SummerSchool.png')"
                  alt
                  class="full-img"
                />
              </div>

              <!-- BOTTOM CONTENT -->
              <div class="bottom-content">
                <div class="title-text brand_navy font-weight-bold">
                  {{
                    subscription_status ? "Continue Learning" : "Get Started"
                  }}
                </div>

                <div class="meta-text color_ash">
                  {{
                    subscription_status
                      ? "Watch this week's project-based video lessons and get ready for your group classes and assignments."
                      : "  Get access to project-based video lessons, group classes and assignments."
                  }}
                </div>

                <!-- BUTTON -->
                <template>
                  <router-link
                    v-if="subscription_status"
                    :to="{
                      name:
                        account_type === 'parent'
                          ? 'ParentFalseCatchup'
                          : 'StudentFalseCatchup',
                    }"
                    class="btn btn-accent font-weight-500 mx-0"
                    style="width: max-content"
                  >
                    Enroll Today
                  </router-link>

                  <router-link
                    v-else
                    :to="{
                      name:
                        account_type === 'parent'
                          ? 'ParentSummerSchoolPlan'
                          : 'StudentSummerSchoolPlan',
                    }"
                    class="btn btn-accent font-weight-500 mx-0"
                    style="width: max-content"
                  >
                    Subscribe Now
                  </router-link>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- MODAL COMPS -->
    <ChangeClassModal
      v-if="class_modal"
      @closeTriggered="toggleClassModal"
      @updateSchool="$emit('updateSchool')"
    ></ChangeClassModal>

    <InviteSchoolModal
      v-if="invitation_modal"
      @close-triggered="toggleInvitationModal"
    ></InviteSchoolModal>
    <!-- MODAL COMPS -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import GettingStartedTop from "@/components/classComps/feeds/GettingStartedTop";

export default {
  name: "GettingStartedList",

  props: {
    subscription_status: Boolean,
    back_to_school_status: Boolean,
    post_content_length: Number,
    enrolled: Boolean,
  },

  components: {
    GettingStartedTop,
    ChangeClassModal: () =>
      import(
        /* webpackChunkName: "ChangeClassModal" */
        "@/components/modalComps/studentModals/ChangeClassModal"
      ),
    InviteSchoolModal: () =>
      import("@/components/modalComps/teacherModals/InviteSchoolModal"),
    RecommendCard: () =>
      import(
        /* webpackChunkName: "RecommendCard" */
        "@/components/classComps/catchup/RecommendCard"
      ),
  },

  computed: {
    ...mapGetters(["getAuthUser", "getSelectedChildID", "getSummerStatus"]),

    getClaimClickDetails() {
      return {
        user_id: this.user_id,
        page_name: "feed_body",
        action_name: "back2school21",
        url: window.location.origin,
      };
    },
  },

  data() {
    return {
      user_id: this.$route.path.split("/")[3],
      account_type: this.$route.path.split("/")[1],
      class_modal: false,
      has_started_diagnostics: false,
      diagnostics: [],
      recommendation_done: false,
      recommendations: [],
      invitation_modal: false,
      child_name: "",
      show_invite_school_block: false,

      connected_to_school: false,
      invite_parent: false,
      invite_school: false,
      take_practice: false,
    };
  },

  mounted() {
    this.getDiagnosticSubjects();
    this.getChildName();
    this.checkOnboardingProgress();
    this.getRecommendations();
  },

  methods: {
    ...mapActions([
      "diagnosticSubjects",
      "getParentStudentTodo",
      "getParentChildren",
      "getDailyRecommendation",
      "logUserClick",
    ]),

    redirectToLandingPage() {
      location.href = "https://gradely.co/pages/tutoring";
    },

    checkOnboardingProgress() {
      let child_id =
        this.account_type === "parent" ? this.getSelectedChildID : null;

      this.getParentStudentTodo(child_id)
        .then((response) => {
          // console.log("Connections", response);
          this.connected_to_school = response.data.connectedToSchool;
          this.invite_parent = response.data.inviteParent;
          this.invite_school = response.data.connectedToSchool
            ? true
            : response.data.inviteSchool;
          this.take_practice = response.data.takePractice;

          if (this.account_type === "parent")
            this.show_invite_school_block = this.invite_school ? false : true;
          else
            this.show_invite_school_block = this.connected_to_school
              ? false
              : true;
        })
        .catch((err) => console.log(err));
    },

    toggleInvitationModal() {
      this.invitation_modal = !this.invitation_modal;
    },

    toggleClassModal() {
      this.class_modal = !this.class_modal;
    },

    getDiagnosticSubjects() {
      this.diagnosticSubjects(this.getSelectedChildID)
        .then((response) => {
          this.isFetching = false;
          if (response.code === 200) {
            this.diagnostics = response.data;
            this.has_started_diagnostics = response.extra.takenPractice;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isFetching = false;
        });
    },

    getRecommendations() {
      this.getDailyRecommendation(this.getSelectedChildID)
        .then((response) => {
          // console.log(response.data);
          if (response.code === 200) {
            this.recommendations = response.data;

            if (this.recommendations.length) {
              this.recommendation_done = this.recommendations.every(
                (item) => item.is_done === 1
              );
            } else this.recommendations = [];
          }
        })
        .catch((err) => console.log(err));
    },

    getChildName() {
      this.child_name = this.account_type === "parent" ? "your child" : "you";
      if (this.account_type === "parent") {
        this.getParentChildren()
          .then((response) => {
            // console.log(".....", response);

            this.child_name = response.data.filter(
              (child) => child.id == this.getSelectedChildID
            )[0].full_name;
          })
          .catch((err) => console.log(err));
      }
    },

    logClaimClick() {
      this.logUserClick(this.getClaimClickDetails)
        .then((response) => {
          console.log("action log response", response);
        })
        .catch((err) => {
          console.log("error logging user action", err);
        });
    },
  },
};
</script>

<style lang="scss">
.getting-started-container {
  .item-block {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
    padding: 10px 15px;
    margin-bottom: 15px;
  }

  .bottom-row {
    .cover {
      border: 1px solid #dbf5f8;
    }

    .info-container {
      height: 270px;

      @include breakpoint_max(sm) {
        height: 250px;
      }

      .full-img {
        @include img_cover;
      }
    }

    .info-container-sm {
      height: 200px;

      @include breakpoint_max(sm) {
        height: 180px;
      }

      .full-img {
        @include img_cover;
      }
    }

    .bottom-content {
      padding: 13px 10px;

      .title-text {
        font-size: 17px;
        line-height: 19px;
        margin-bottom: 10px;

        @include breakpoint_max(sm) {
          font-size: 14px;
        }
        @include breakpoint_max(xs) {
          font-size: 13px;
        }
      }

      .meta-text {
        font-size: 13.5px;
        line-height: 165%;
        margin-bottom: 15px;
      }

      button {
        font-size: 11px;

        @include breakpoint_max(xs) {
          font-size: 9px !important;
        }
      }
    }

    .recommendation-container {
      width: 90%;

      @include breakpoint_max(md) {
        width: 100%;
      }

      .recommendation-row {
        overflow: auto;

        &::-webkit-scrollbar {
          height: 8px;
        }

        &::-webkit-scrollbar-track {
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background: $color_grey_light;
        }
      }
    }

    .title-one {
      font-size: 14px;
      line-height: 160%;

      @include breakpoint_max(xs) {
        font-size: 13px;
      }
    }

    .text-content {
      padding-top: 24px;
      padding-left: 20px;
      padding-right: 20px;

      .text {
        margin-top: 5px;
        font-size: 17px;
      }

      .title-one {
        font-size: 22px;
        line-height: 32px;
        margin-bottom: 15px;
        width: 50%;

        @include breakpoint_max(sm) {
          font-size: 20px;
          line-height: 28px;
          width: 80%;
        }
      }

      .subtitle-one {
        font-size: 12.5px;
        line-height: 165%;
        margin-bottom: 21px;
        width: 70%;

        @include breakpoint_max(sm) {
          font-size: 12px;
          width: 90%;
        }
      }

      .btn {
        @include breakpoint_max(sm) {
          font-size: 10px !important;
        }
      }
    }

    .content {
      padding: 25px 0px;

      .img-content {
        @include custom_min_edge(225, 240);
        position: relative;
        margin-right: 15px;

        @include breakpoint_max(sm) {
          @include custom_min_edge(200, 220);
          margin-right: 10px;
        }

        @include breakpoint_max(xs) {
          @include custom_min_edge(165, 200);
          margin-right: 7px;
        }

        @include breakpoint_min_max(355, 390) {
          @include custom_min_edge(150, 170);
        }

        @include breakpoint_min_max(330, 354) {
          @include custom_min_edge(135, 160);
        }

        img {
          @include img_cover;
        }
      }

      .title-two {
        font-weight: 900;
        font-size: 25px;
        line-height: 32px;
        margin-bottom: 15px;
        width: 60%;

        @include breakpoint_max(sm) {
          font-size: 20px;
          line-height: 28px;
          width: 90%;
        }

        @include breakpoint_max(xs) {
          font-size: 18px;
          line-height: 26px;
        }
      }

      .subtitle-two {
        font-size: 12.5px;
        line-height: 165%;
        margin-bottom: 20px;

        @include breakpoint_max(sm) {
          font-size: 12px;
        }
      }

      .btn {
        @include breakpoint_max(sm) {
          font-size: 10px !important;
        }
      }
    }
  }
}

.strike-through {
  text-decoration: line-through;
}
</style>
